import React, { forwardRef } from 'react';

import MUIButtonGroup, {
  ButtonGroupProps as MUIButtonGroupProps,
} from '@material-ui/core/ButtonGroup';

interface ButtonGroupProps extends MUIButtonGroupProps {}

const ButtonGroup = forwardRef<any, ButtonGroupProps>((props, ref) => {
  return (
    <MUIButtonGroup {...props} ref={ref}>
      {props.children}
    </MUIButtonGroup>
  );
});

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
